<script setup lang="tsx">
import { ref } from "vue";
import Dialog from "./Dialog.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Dialog },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    content?: string;
    during?: number;
    closeWhenClickOverlay?: boolean;
    dur?: number;
  }>(),
  {
    content: "",
    during: 1500,
    closeWhenClickOverlay: false,
    dur: 200
  }
);

const emits = defineEmits<{
  (event: "open"): void;
  (event: "close"): void;
}>();

const dialog = ref();

function open() {
  dialog.value.open();
  setTimeout(() => {
    close();
  }, props.during);
}

function close() {
  dialog.value.close();
}

defineExpose({
  open,
  close
});
</script>

<template>
  <Dialog
    ref="dialog"
    :showConfirm="false"
    :showTitle="false"
    :closeWhenClickOverlay="props.closeWhenClickOverlay"
    :dur="props.dur"
    overlayBgColor="transparent"
    minWidth="160px"
    borderRadius="8px"
    @open="() => emits('open')"
    @close="() => emits('close')"
  >
    <div class="toast">
      <div class="content">
        {{ content }}
      </div>
    </div>
  </Dialog>
</template>

<style scoped>
.toast {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #333333;
  color: #cccccc;
  padding: 1em 1em;
}
.content {
  font-size: 1em;
}
</style>
